<template>
  <div>
    <component
      :is="block.type"
      v-for="(block, i) in blocks"
      :key="i"
      v-bind="block.props"
      class="promo-block"
      :white_buttons="whiteButtons"
      @promo-banner-click="sendAnaliticsBannerClick(i)"
    >
      {{ block }}
    </component>
  </div>
</template>

<script lang="ts" src="./PromoSlugTs.ts"></script>
<style scoped lang="scss" src="./PromoSlugScss.scss"></style>
